// extracted by mini-css-extract-plugin
export default {"noNetworkContainer":"NoNetworkScreen_noNetworkContainer__iIyzV","icon":"NoNetworkScreen_icon__QMkaL"};